//
import localizeValue from './localizeValue';

// ----------------------------------------------------------------------

export function errorHandler(error, defaultMsg) {
  function handler() {
    if (error?.ar || typeof error === 'string') return localizeValue(error);
    if (error?.code === 'invalid') {
      if (error.message?.non_field_errors) return localizeValue(error.message.non_field_errors[0]);
      if (error.message?.ar || typeof error.message === 'string') return localizeValue(error.message);
      if (error.message?.ar || typeof error.message === 'object') return localizeValue(error.message[0]);
      return Object.keys(error.message)
        .map((item) => localizeValue(error.message[item][0]))
        .join('\n');
    }
    return defaultMsg;
  }
  return handler().slice(0, 250);
}
